export enum DataProfileType {
  ORDER,
  TRADE,
  DEALER_INTERVENTION,
  OPERATIONS,
  POSITIONS,
  SCRATCHPAD,
  OPS_INTERVENTION,
  BENCHMARK,
  RISK_TRADE,
}

export namespace DataProfileType {
  let elements = [
    DataProfileType.ORDER,
    DataProfileType.TRADE,
    DataProfileType.DEALER_INTERVENTION,
    DataProfileType.OPERATIONS,
    DataProfileType.POSITIONS,
    DataProfileType.SCRATCHPAD,
    DataProfileType.OPS_INTERVENTION,
    DataProfileType.BENCHMARK,
    DataProfileType.RISK_TRADE,
  ];
  let alias = "com.bcdfx.servicerequest.dataprofile.DataProfileType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
